export default __webpack_public_path__ + "static/media/phone.cba39c4d.svg";